import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { useTranslation } from "react-i18next";
import DialogTitleWithClose from "./DialogTitleWithClose";

interface IProps {
	onClose: () => void
	titleText?: string;
	contentText?: string;
}

export default function ErrorModal(props: IProps) {

	const { t } = useTranslation();

	let titleText = "Nieprzewidziany błąd aplikacji!";
	let contentText = "Skontaktuj się z administratorem...";

	if (props.titleText) {
		titleText = props.titleText;
	}

	if (props.contentText) {
		contentText = props.contentText;
	}

	return <Dialog
		open={true}
		onClose={(e) => props.onClose()}
	>
		<DialogTitleWithClose onClose={props.onClose} >{titleText}</DialogTitleWithClose>
		<DialogContent>
			<DialogContentText>
				{contentText}
			</DialogContentText>
		</DialogContent>
		<DialogActions>
			<Button onClick={props.onClose} color="default" variant="contained">
				{t('common.action.close')}
			</Button>
		</DialogActions>
	</Dialog>
}